// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".module-menu-icon{display:flex;justify-content:center;width:3.5em}", ""]);
// Exports
module.exports = exports;
